<div class="main">
    <div class="dx-field-title" translate>localAgentsCommands.pageTitle</div>
    <div class="dx-fieldset">
        <div class="dx-field selector">
            <div class="dx-field-label">{{ this.currentEnvironmentName }}&nbsp;/</div>
            <div class="dx-field-value">
                <dx-select-box #agentPicker
                               displayExpr="name" 
                               valueExpr="id" 
                               [dataSource]="localAgents" 
                               [noDataText]="'_pickers.nodata' | translate"
                               [placeholder]="'_pickers.placeholder' | translate"
                               (selectedItemChange)="filterChanged($event)">
                </dx-select-box>
            </div>
        </div>
    </div>
    <br />
    <div style="height:calc(100vh - 210px)">
        <dx-data-grid #commands
                      height="100%"
                      hoverStateEnabled="true"
                      keyExpr="id"
                      [columnAutoWidth]="true"
                      [dataSource]="dataSource"
                      [errorRowEnabled]="false"
                      (onContextMenuPreparing)="onContextMenuPreparing($event)"
                      (onRowDblClick)="onRowClick($event)">
            <dxo-search-panel [visible]="true" [width]="250" [placeholder]="'_commons.search' | translate"></dxo-search-panel>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-load-panel [enabled]="showGridLoadingPanel" [text]="'_commons.loading' | translate"></dxo-load-panel>
            <dxo-paging [enabled]="false"></dxo-paging>
            <dxo-summary>
                <dxi-total-item column="command" [displayFormat]="'localAgentsCommands.lblCommandsCount' | translate" summaryType="count"></dxi-total-item>
            </dxo-summary>
            <dxo-toolbar>
                <dxi-item location="before">
                    <div *dxTemplate>
                        <dx-date-range-box applyValueMode="useButtons" labelMode="hidden" width="300" [max]="maxDate" [(value)]="selectedDates" (onValueChanged)="dateChanged()"></dx-date-range-box>
                    </div>
                </dxi-item>
                <dxi-item location="after">
                    <div *dxTemplate>
                        <dx-button icon="refresh" [text]="'_commons.refresh' | translate" (onClick)="refresh()"></dx-button>
                    </div>
                </dxi-item>
                <dxi-item name="searchPanel"></dxi-item>
            </dxo-toolbar>

            <dxi-column dataField="command" [caption]="'localAgentsCommands.lblCommand' | translate" [calculateCellValue]="displayCommand"></dxi-column>
            <dxi-column dataField="status" [caption]="'localAgentsCommands.lblStatus' | translate" [calculateCellValue]="displayStatus"></dxi-column>
            <dxi-column dataField="fileTransferName" [caption]="'localAgentsCommands.lblTransfer' | translate"></dxi-column>
            <dxi-column dataField="remotePlatformName" [caption]="'localAgentsCommands.lblRemotePlatform' | translate"></dxi-column>
            <dxi-column dataField="target" [caption]="'localAgentsCommands.lblTarget' | translate" [calculateCellValue]="displayTarget"></dxi-column>
            <dxi-column dataField="requestedByUser.displayName" [caption]="'localAgentsCommands.lblRequestedBy' | translate" [calculateCellValue]="displayName"></dxi-column>
            <dxi-column dataField="createdOn" [caption]="'localAgentsCommands.lblCreatedOnUtc' | translate" dataType="datetime" format="MMMM d, yyyy HH:mm:ss"/>
            <dxi-column dataField="startedOn" [caption]="'localAgentsCommands.lblStartedOnUtc' | translate" dataType="datetime" format="MMMM d, yyyy HH:mm:ss"/>
            <dxi-column dataField="completedOn" [caption]="'localAgentsCommands.lblCompletedOnUtc' | translate" dataType="datetime" format="MMMM d, yyyy HH:mm:ss"/>
        </dx-data-grid>
    </div>
</div>

<!-- Display popup -->
<app-local-agent-command #agentCommandPopup></app-local-agent-command>

<!-- Loading panel -->
<dx-load-panel [visible]="isLoadPanelVisible" [message]="'_commons.loading' | translate" [position]="{ of: '.app-content', boundary: '.app-content' }"></dx-load-panel>
